import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const getSoilSensors = async (setData, groupId, { number, serialNumber }, page, size) => {
  return await axios.get(`soil-sensors/groups/${groupId}/search-page?number=${number}${encodeURIComponent(serialNumber)}&page=${page}&size=${size}`)
    .then((response) => {
      setData(response.data.data);
    })
    .catch(() => {});
};

export default getSoilSensors;